import React, { FC } from 'react';

import { Lock as LockIcon } from '@/shared/assets/Lock';

import styles from './_Lock.module.css';

export const Lock: FC = () => (
    <div className={styles.root}>
        <LockIcon />
    </div>
);
